import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, Link, useParams } from 'react-router-dom';
import { 
  Shield, BarChart3, Users, TrendingUp, Menu, X, LogOut, 
  Filter, AlertTriangle, Globe, Activity, Plane, MapPin
} from 'lucide-react';
import DOMPurify from "dompurify";
import { api } from './convex/_generated/api';
import { useQuery, useAction,useMutation } from 'convex/react';
import { useNavigate } from 'react-router-dom';


const TravalDashboard = () => {
  const [transactions, setTransactions] = useState([]);
  const location = useLocation();
  const [filtered, setFiltered] = useState([]);
  const [metrics, setMetrics] = useState({});
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedComments, setSelectedComments] = useState({});
  const [statusChanges, setStatusChanges] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const sessionId = localStorage.getItem('session_id') || location.state?.sessionId ;
  const [demoKey, setDemoKey] = useState(
  localStorage.getItem("demoKey") || ""
);
  const navigate = useNavigate();
  const user = useQuery(api.users.getUserBySession,
      sessionId ? { sessionId } : "skip"
    );
  

  const pageSize = 20;
  
  const username = user?.fullName || '';
  
  const [country, setCountry] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [noticeMessage, setNoticeMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const logoutUser = useAction(api.mfa.logoutUser);

  const handleSignOut = async () => {
    if (user) {
      await logoutUser({ sessionId });
      localStorage.removeItem('session_id');
      navigate('/');
    } else {
      navigate('/auth');
    }
  };

  useEffect(() => {
    filterTransactions();
  }, [statusFilter, transactions]);

  const filterTransactions = () => {
    let temp = [...transactions];
    if (statusFilter) {
      temp = temp.filter((t) => {
        if (statusFilter === "fraud") return t.is_fraud === 1;
        if (statusFilter === "non-fraud") return t.is_fraud === 0;
        return true;
      });
    }
    setFiltered(temp);
    //setTransactions(temp);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/submit_travel_notice/${username}`,
        {
          username,
          country,
          start_date: startDate,
          end_date: endDate,
        },
        {
    headers: {
      'x-api-key': demoKey,
    },
  }
      );
      setLoading(false);
  
      fetchTransactions();
      setNoticeMessage("✈️ Travel notice submitted successfully!");
    } catch (err) {
      console.error(err);
      setLoading(false);
      setNoticeMessage("Error submitting travel notice.");
    }
  };

  const fetchTransactions = async () => {
    try {

       const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/traveltransactions/${username}`,
      {
        params: {
          country: country,
        },
        headers: {
          "x-api-key": demoKey,
        },
      }
    );
      setTransactions(Array.isArray(response.data) ? response.data : []);
     
    } catch (err) {
      console.error(err);
      setTransactions([]);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [username,country]);

  const NavItem = ({ icon: Icon, label, to }) => (
    <Link
      to={to}
      state={{ username }}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        borderRadius: '10px',
        textDecoration: 'none',
        color: '#94a3b8',
        transition: 'all 0.2s',
        gap: 12,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(99,102,241,0.1)';
        e.currentTarget.style.color = '#6366f1';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
        e.currentTarget.style.color = '#94a3b8';
      }}
    >
      <Icon size={18} />
      {label}
    </Link>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#060818', fontFamily: "'Inter', sans-serif", color: '#e2e8f0' }}>

      {/* Sidebar */}
      <div style={{
        position: 'fixed',
        top: 0, bottom: 0, left: 0,
        width: 260,
        transform: sidebarOpen ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform 0.3s ease',
        zIndex: 1000,
        background: '#0a0d1f',
        borderRight: '1px solid #1a1f3a',
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px', borderBottom: '1px solid #1a1f3a' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Plane size={18} color="#fff" />
            </div>
            <span style={{ fontWeight: 700, fontSize: 18, color: '#f1f5f9' }}>TravelGuard</span>
          </div>
          <button onClick={() => setSidebarOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b' }}>
            <X size={20} />
          </button>
        </div>

        {/* Nav */}
        <nav style={{ padding: '16px 12px', display: 'flex', flexDirection: 'column', gap: 4 }}>
          <NavItem icon={Activity} label="Analytics" to={`/analyticstwo/${username}`} />
          <NavItem icon={BarChart3} label="Charts" to={`/chartstwo/${username}`} />
          <NavItem icon={Globe} label="Dashboard" to={`/dashboardfraudparttwo/${username}`} />
          <NavItem icon={TrendingUp} label="SMS Data" to={`/dashboarsmsparttwo/${username}`} />
          <NavItem icon={TrendingUp} label="Keystrokes Data" to={`/dashboardkeystrokesparttwo/${username}`} />
        </nav>

        {/* User */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '20px 24px', borderTop: '1px solid #1a1f3a' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 14 }}>
              {username}
            </div>
            <div>
              <p style={{ color: '#f1f5f9', fontSize: 14, fontWeight: 500, margin: 0 }}>User {username}</p>
              <p style={{ color: '#64748b', fontSize: 12, margin: 0 }}>Travel Dashboard</p>
            </div>
          </div>
          <button
            onClick={handleSignOut}
            style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#64748b', background: 'none', border: 'none', cursor: 'pointer', fontSize: 14 }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#f1f5f9'}
            onMouseLeave={(e) => e.currentTarget.style.color = '#64748b'}
          >
            <LogOut size={16} /> Sign Out
          </button>
        </div>
      </div>

      {/* Overlay */}
      {sidebarOpen && (
        <div
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 999 }}
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

        {/* Header */}
        <header style={{
          position: 'sticky', top: 0, zIndex: 100,
          background: 'rgba(6,8,24,0.95)',
          backdropFilter: 'blur(16px)',
          borderBottom: '1px solid #1a1f3a',
          padding: '0 24px',
          height: 64,
          display: 'flex',
          alignItems: 'center',
          gap: 16,
        }}>
          <button
            onClick={() => setSidebarOpen(true)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', padding: 8, borderRadius: 8 }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#1a1f3a'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <Menu size={22} />
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Plane size={20} color="#6366f1" />
            <h1 style={{ fontSize: 20, fontWeight: 700, color: '#f1f5f9', margin: 0 }}>Travel Dashboard</h1>
          </div>
        </header>

        {/* Content */}
        <main style={{ padding: 24, flex: 1 }}>

          {/* Stats */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginBottom: 24 }}>
            {[
              { label: 'Total Transactions', value: filtered.length, icon: Activity, color: '#6366f1' },
              { label: 'Fraud Detected', value: filtered.filter(t => t.is_fraud === 1).length, icon: AlertTriangle, color: '#ef4444' },
              { label: 'Normal', value: filtered.filter(t => t.is_fraud === 0).length, icon: Shield, color: '#22c55e' },
              { label: 'Countries', value: new Set(filtered.map(t => t.geo_location)).size, icon: MapPin, color: '#f59e0b' },
            ].map((stat, i) => (
              <div key={i} style={{ background: '#0a0d1f', border: '1px solid #1a1f3a', borderRadius: 14, padding: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 44, height: 44, borderRadius: 12, background: `${stat.color}20`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <stat.icon size={20} color={stat.color} />
                  </div>
                  <div>
                    <p style={{ fontSize: 12, color: '#64748b', margin: 0 }}>{stat.label}</p>
                    <p style={{ fontSize: 24, fontWeight: 800, color: '#f1f5f9', margin: 0 }}>{stat.value}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Travel Notice Form */}
          <div style={{ background: '#0a0d1f', border: '1px solid #1a1f3a', borderRadius: 14, padding: 24, marginBottom: 24 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
              <Plane size={18} color="#6366f1" />
              <h2 style={{ fontSize: 16, fontWeight: 700, color: '#f1f5f9', margin: 0 }}>Submit Travel Notice</h2>
            </div>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'flex-end' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1, minWidth: 160 }}>
                <label style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>Country</label>
                <input
                  type="text"
                  value={demoKey}
                  onChange={(e) => {
                    setDemoKey(e.target.value);
                    localStorage.setItem("demoKey", e.target.value);
                  }}
                  placeholder="enter demokey"
                  required
                  style={{ padding: '10px 14px', background: '#060818', border: '1px solid #1a1f3a', borderRadius: 8, color: '#f1f5f9', fontSize: 14, outline: 'none' }}
                  onFocus={(e) => e.target.style.borderColor = '#6366f1'}
                  onBlur={(e) => e.target.style.borderColor = '#1a1f3a'}
                />
                <input
                  type="text"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  placeholder="e.g. France"
                  required
                  style={{ padding: '10px 14px', background: '#060818', border: '1px solid #1a1f3a', borderRadius: 8, color: '#f1f5f9', fontSize: 14, outline: 'none' }}
                  onFocus={(e) => e.target.style.borderColor = '#6366f1'}
                  onBlur={(e) => e.target.style.borderColor = '#1a1f3a'}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1, minWidth: 160 }}>
                <label style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>Start Date</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  required
                  style={{ padding: '10px 14px', background: '#060818', border: '1px solid #1a1f3a', borderRadius: 8, color: '#f1f5f9', fontSize: 14, outline: 'none' }}
                  onFocus={(e) => e.target.style.borderColor = '#6366f1'}
                  onBlur={(e) => e.target.style.borderColor = '#1a1f3a'}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1, minWidth: 160 }}>
                <label style={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>End Date</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  required
                  style={{ padding: '10px 14px', background: '#060818', border: '1px solid #1a1f3a', borderRadius: 8, color: '#f1f5f9', fontSize: 14, outline: 'none' }}
                  onFocus={(e) => e.target.style.borderColor = '#6366f1'}
                  onBlur={(e) => e.target.style.borderColor = '#1a1f3a'}
                />
              </div>
              <button
                type="submit"
                style={{ padding: '10px 24px', background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', border: 'none', borderRadius: 8, color: '#fff', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}
              >
                ✈️ Submit
              </button>
            </form>
            {noticeMessage && (
              <p style={{ marginTop: 12, fontSize: 13, color: noticeMessage.includes('Error') ? '#ef4444' : '#22c55e' }}>
                {noticeMessage}
              </p>
            )}
          </div>

          {/* Filter */}
          <div style={{ background: '#0a0d1f', border: '1px solid #1a1f3a', borderRadius: 14, padding: '16px 24px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
            <Filter size={16} color="#64748b" />
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{ padding: '8px 14px', background: '#060818', border: '1px solid #1a1f3a', borderRadius: 8, color: '#f1f5f9', fontSize: 14, outline: 'none', cursor: 'pointer' }}
            >
              <option value="">All Status</option>
              <option value="non-fraud">Normal</option>
              <option value="fraud">Fraud</option>
            </select>
          </div>

          {/* Transactions Table */}
          <div style={{ background: '#0a0d1f', border: '1px solid #1a1f3a', borderRadius: 14, overflow: 'hidden' }}>
            <div style={{ padding: '16px 24px', borderBottom: '1px solid #1a1f3a', display: 'flex', alignItems: 'center', gap: 10 }}>
              <Activity size={16} color="#6366f1" />
              <h3 style={{ fontSize: 14, fontWeight: 700, color: '#f1f5f9', margin: 0 }}>Transactions</h3>
              <span style={{ marginLeft: 'auto', fontSize: 12, color: '#64748b' }}>{filtered.length} total</span>
            </div>
            <div style={{ overflowX: 'auto', maxHeight: 500, overflowY: 'auto' }}>
              <table style={{ width: '100%', minWidth: 1000, borderCollapse: 'collapse', fontSize: 13 }}>
                <thead style={{ background: '#060818', position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr>
                    {['User ID', 'Transaction ID', 'Amount', 'Geo Location', 'Decision', 'Fraud Probability', 'Status'].map((h, i) => (
                      <th key={i} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap', borderBottom: '1px solid #1a1f3a' }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((transaction) => (
                    <tr
                      key={transaction.transaction_id}
                      style={{ borderBottom: '1px solid #0f1729', transition: 'background 0.15s' }}
                      onMouseEnter={(e) => e.currentTarget.style.background = '#0f1729'}
                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                    >
                      <td style={{ padding: '12px 16px', color: '#94a3b8' }}>{DOMPurify.sanitize(String(transaction.username))}</td>
                      <td style={{ padding: '12px 16px', color: '#64748b', fontFamily: 'monospace', fontSize: 12 }}>{DOMPurify.sanitize(String(transaction.transaction_id))}</td>
                      <td style={{ padding: '12px 16px', color: '#f1f5f9', fontWeight: 600 }}>${DOMPurify.sanitize(String(transaction.amount))}</td>
                      <td style={{ padding: '12px 16px', color: '#94a3b8' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <MapPin size={12} color="#6366f1" />
                          {DOMPurify.sanitize(String(transaction.geo_location))}
                        </div>
                      </td>
                      <td style={{ padding: '12px 16px', color: '#94a3b8' }}>{DOMPurify.sanitize(String(transaction.decision))}</td>
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <div style={{ flex: 1, height: 4, background: '#1a1f3a', borderRadius: 2, overflow: 'hidden' }}>
                            <div style={{ height: '100%', width: `${transaction.fraud_probability * 100}%`, background: transaction.fraud_probability > 0.5 ? '#ef4444' : '#22c55e', borderRadius: 2 }} />
                          </div>
                          <span style={{ fontSize: 12, color: '#64748b', minWidth: 36 }}>{transaction.fraud_probability.toFixed(2)}</span>
                        </div>
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{
                          display: 'inline-flex', alignItems: 'center', gap: 4,
                          padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600,
                          background: transaction.is_fraud === 1 ? 'rgba(239,68,68,0.1)' : 'rgba(34,197,94,0.1)',
                          color: transaction.is_fraud === 1 ? '#ef4444' : '#22c55e',
                        }}>
                          {transaction.is_fraud === 1 ? <><AlertTriangle size={10} /> Fraud</> : <><Shield size={10} /> Normal</>}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {loading && (
                <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Loading transactions...</div>
              )}
              {!loading && transactions.length === 0 && (
                <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>No transactions found</div>
              )}
            </div>
          </div>

        </main>
      </div>
    </div>
  );
};

export default TravalDashboard;
